const deviceType = getPlatform()
function appAgentFirstInstall() {
  const appInfo: any = appAgentParams()
  const userAgent = navigator.userAgent
  // ios
  if (deviceType == 1) {
    const splitArr = userAgent.split('firstInstall=')
    if (splitArr.length == 2) {
      return splitArr[1]
    }
  }
  // 安卓
  if (deviceType == 0) {
    return appInfo.firstInstall
  }
}
const getAnonymousID = () => {
  if (window.sensors) {
    const anonymous_id = window?.sensors?.quick('getAnonymousID')
    return {
      '0': appAgentFirstInstall() || anonymous_id,
      '1': appAgentFirstInstall() || anonymous_id,
      '2': anonymous_id
    }[deviceType]
  }
}
const setAppInstall = () => {
  const { tenantId, webSiteId, appConfig }: any = storeToRefs(useGlobalStore())
  if (window.sensors) {
    window.sensors.track('AppInstall', {
      os_name: deviceType,
      channel_id: appConfig.value.channelId,
      device_id: getAnonymousID(),
      project_id: appConfig.value.projectIds,
      web_site_id: webSiteId.value,
      tenant_id: tenantId.value
    })
  }
}
export const trackAppInstall = () => {
  // 包壳
  if (deviceType != 2) {
    if (appAgentFirstInstall()) {
      setAppInstall()
    }
  } else {
    // h5
    if (localStorage.getItem('AppInstall')) {
      console.log('h5-已存在appinstall')
      return
    }
    setAppInstall()
    console.log('执行appinstall')
    // setAppInstall()
    localStorage.setItem('AppInstall', '1')
  }
}
